// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_fS","gallery__header":"c-p_fT","gallery__thumbs":"c-p_fU"};